import { render, staticRenderFns } from "./OrderControls.vue?vue&type=template&id=4ed463ee"
import script from "./OrderControls.vue?vue&type=script&lang=js"
export * from "./OrderControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports